import { buildAvailityConfig } from "../payors/tenantPayors.mjs";

//#region src/clinicConfig/build.ts
/**
* Assemble a tenant's clinic config from its payor registry and EHR maps.
*
* Tenants go through this rather than writing the object literal directly so
* `availity` cannot be hand-written, and cannot be built from a different payor
* list than the one the tenant publishes — the registry is named once and read
* once. Everything derived from it (the Availity payer names, the portal
* routing, the insurance-modal dropdown, the prior-auth and eligibility gates)
* therefore agrees by construction rather than by review.
*/
function buildClinicConfig(input) {
	return {
		payors: input.payors,
		athenaPayorMappings: input.athenaPayorMappings,
		azaleaPayorMappings: input.azaleaPayorMappings,
		availity: buildAvailityConfig(input.payors, { insuranceGroupToInfoMapping: input.insuranceGroupToInfoMapping })
	};
}

//#endregion
export { buildClinicConfig };